import {Injectable} from '@angular/core';
import {Store as TagStore, TagState} from './store';
import {EntityService} from '../../../components/entity-service';
import {Tag} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {TagQuery} from './query';

@Injectable({ providedIn: 'root' })
export class TagService extends EntityService<TagStore, TagState> {

  tags$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new Tag(item))),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('tag.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('tag.name'),
        inputType: 'text',
        name: 'name',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: TagQuery,
    protected store: TagStore) {
    super(store, Tag);
  }

  get resourceName(): string {
    return 'content/tag';
  }

}
